import React, { useEffect, useImperativeHandle, useRef, useState } from 'react';
import { ZdsButton, ZdsCheckbox, ZdsForm, ZdsIcon, ZdsInputDate, ZdsInputNumber, ZdsModal, } from '@zig-design-system/ui-components-react';
import Translation from '../../../../Shared/components/Translation';
import { renderToString } from 'react-dom/server';
const HousingCostsModal = React.forwardRef(({ savedData, onSave }, ref) => {
    const dateRef = useRef(null);
    const emptyResident = {
        id: 0,
        income: '',
        birthdate: null,
    };
    const [rememberData, setRememberData] = useState(true);
    const [residents, setResidents] = useState([]);
    useEffect(() => {
        var _a;
        setRememberData(savedData.rememberData);
        setResidents(savedData.residents.length > 0 ? savedData.residents : [emptyResident]);
        if (savedData.residents.length == 0) {
            (_a = dateRef.current) === null || _a === void 0 ? void 0 : _a.reset();
        }
    }, [savedData]);
    const getNextResidentId = () => {
        return Math.max(...residents.map((resident) => resident.id)) + 1;
    };
    const setBirthdate = (targetResident, birthdate) => {
        const updatedResident = Object.assign(Object.assign({}, targetResident), { birthdate: birthdate });
        setResidents(residents.map((resident) => (resident === targetResident ? updatedResident : resident)));
    };
    const setIncome = (targetResident, income) => {
        const updatedResident = Object.assign(Object.assign({}, targetResident), { income: income ? parseInt(income) : '' });
        setResidents(residents.map((resident) => (resident === targetResident ? updatedResident : resident)));
    };
    const addResident = () => {
        setResidents([...residents, Object.assign(Object.assign({}, emptyResident), { id: getNextResidentId() })]);
    };
    const removeResident = (targetResident) => {
        setResidents(residents.filter((resident) => resident !== targetResident));
    };
    const handleRememberCheckboxChanged = (event) => {
        setRememberData(event.target.checked);
    };
    const handleFormSubmitted = (event) => {
        event.target.querySelector('zds-modal').hide('save');
    };
    const handleModalHidden = (event) => {
        if (event.detail.action !== 'save') {
            setResidents(savedData.residents.length > 0 ? savedData.residents : [emptyResident]);
            setRememberData(savedData.rememberData);
        }
        else {
            onSave({ residents, rememberData });
        }
    };
    useImperativeHandle(ref, () => {
        return {
            open: () => {
                const modal = document.getElementById('housing-costs-modal');
                modal.show();
            },
        };
    });
    return (React.createElement(ZdsForm, { onZdsSubmit: handleFormSubmitted },
        React.createElement(ZdsModal, { id: "housing-costs-modal", onZdsModalHidden: handleModalHidden },
            React.createElement("div", { slot: "header" },
                React.createElement(Translation, { item: "tx_zigrealestate.details.housingCosts.modal.header" })),
            React.createElement(ZdsButton, { slot: "header-end", "zds-modal-action": "closeButton", variant: "text" },
                React.createElement(ZdsIcon, { "aria-label": "close", name: "close" })),
            React.createElement("div", { slot: "body" },
                React.createElement("div", { className: "zd-body zds-margin-bottom-6" },
                    React.createElement(Translation, { item: "tx_zigrealestate.details.housingCosts.modal.intro" })),
                React.createElement("div", { className: "zds-flex-col zds-gap-y-12" },
                    residents.map((resident, index) => (React.createElement("fieldset", { className: "zds-flex-col zds-gap-y-4", key: resident.id },
                        React.createElement("legend", { className: "zds-headline-sm zds-flex-row zds-margin-bottom-3" },
                            React.createElement(Translation, { item: "tx_zigrealestate.details.housingCosts.modal.resident" }),
                            ' ',
                            index + 1,
                            index > 0 && (React.createElement(ZdsButton, { onZdsClick: () => {
                                    removeResident(resident);
                                }, variant: "text", preset: "neutral", pill: true, className: "housing-costs-remove zds-margin-left-auto" },
                                React.createElement(ZdsIcon, { library: "fa-solid", name: "trash", size: "sm" })))),
                        React.createElement(ZdsInputNumber, { label: renderToString(React.createElement(Translation, { item: "tx_zigrealestate.details.housingCosts.modal.income", asString: true })), value: resident.income, onZdsChange: (event) => setIncome(resident, event.target.value), required: true },
                            React.createElement("span", { slot: "content-start" }, "\u20AC")),
                        React.createElement(ZdsInputDate, { required: true, value: resident.birthdate, visualFormat: "dd-MM-yyyy", format: "yyyy-MM-dd", label: renderToString(React.createElement(Translation, { item: "tx_zigrealestate.details.housingCosts.modal.birthdate", asString: true })), onZdsChange: (event) => setBirthdate(resident, event.target.value), calendar: "off", ref: dateRef },
                            React.createElement("span", { slot: "validation-message", "data-reason": "badInputInvalid" },
                                React.createElement(Translation, { item: "tx_zigrealestate.details.housingCosts.modal.birthdateInvalid" })))))),
                    React.createElement(ZdsButton, { onZdsClick: addResident, preset: "primary", variant: "outlined" },
                        React.createElement(ZdsIcon, { library: "fa-solid", name: "plus", size: "sm" }),
                        React.createElement(Translation, { item: "tx_zigrealestate.details.housingCosts.modal.addResident" })))),
            React.createElement("div", { slot: "footer", className: "zds-flex zds-justify-content-between" },
                React.createElement(ZdsCheckbox, { checked: rememberData, onZdsChange: handleRememberCheckboxChanged },
                    React.createElement(Translation, { item: "tx_zigrealestate.details.housingCosts.modal.rememberData" })),
                React.createElement(ZdsButton, { slot: "footer", preset: "primary", variant: "contained", type: "submit" },
                    React.createElement(Translation, { item: "tx_zigrealestate.details.housingCosts.modal.submit" }))))));
});
export default HousingCostsModal;
